import { render, staticRenderFns } from "./HeaderNotification.vue?vue&type=template&id=4437fc38&scoped=true"
import script from "./HeaderNotification.vue?vue&type=script&lang=ts"
export * from "./HeaderNotification.vue?vue&type=script&lang=ts"
import style0 from "./HeaderNotification.vue?vue&type=style&index=0&id=4437fc38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4437fc38",
  null
  
)

export default component.exports